import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import { Tracker } from '../Tracker';
import { SAFER_GAMBLING_EVENT_NAME } from './constants';

export var AccountClosureTracker = function (_Tracker) {
  _inherits(AccountClosureTracker, _Tracker);

  function AccountClosureTracker() {
    _classCallCheck(this, AccountClosureTracker);

    return _possibleConstructorReturn(this, (AccountClosureTracker.__proto__ || _Object$getPrototypeOf(AccountClosureTracker)).apply(this, arguments));
  }

  _createClass(AccountClosureTracker, [{
    key: 'closeAccountClicked',
    value: function closeAccountClicked(value) {
      this.publishPartialEvent(SAFER_GAMBLING_EVENT_NAME, {
        EventAction: 'Account Closure',
        SiteSectionCategory: 'Account closure',
        EventLabel: this.parseAccountClosureValueToEventLabel(value)
      });
    }
  }, {
    key: 'parseAccountClosureValueToEventLabel',
    value: function parseAccountClosureValueToEventLabel(reasonId) {
      var reasons = [{ id: 'CLOSURE_REASON_OFFERS', text: 'I am not happy with your offers' }, { id: 'CLOSURE_REASON_PRODUCTS', text: 'I am not happy with your products' }, { id: 'CLOSURE_REASON_SERVICE', text: 'I am not happy with your service' }, { id: 'CLOSURE_REASON_TIME', text: 'I do not have enough time to use my account anymore' }, { id: 'CLOSURE_REASON_CHANGES', text: 'I do not like the changes you recently made' }, { id: 'CLOSURE_REASON_PROVIDER', text: 'I now use another provider' }, { id: 'CLOSURE_REASON_SECRET', text: 'I would prefer not to say' }];

      var result = reasons.find(function (_ref) {
        var id = _ref.id;
        return id === reasonId;
      });

      var reason = result ? result.text : 'error';
      return 'Reason: ' + reason;
    }
  }]);

  return AccountClosureTracker;
}(Tracker);